<template>
    <div class="row">
        <div class="col-6">
            <form-container :passedData="user" />
        </div>
        <div class="col-6">
            <p>User children</p> 
            <multiselect v-model="value" :options="children">
            </multiselect>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import Multiselect from 'vue-multiselect';

    import UserRegistrationForm from '../../../components/Panel/Registration/User/UserRegistrationForm';
    import RegisterForm from '../../../components/Panel/Registration/User/RoleSpecificForms/RegisterForm'; 
    import Table from '../../../components/Panel/Table/Table';

    export default {
        name: 'users-shop',
        components: {
            'form-container': UserRegistrationForm,
            Multiselect,
        },
        data() {
            return {
                user: null,
                value: null,
                children: []
            }
        },
        async created() {
            this.user = await this.getUsers.find(user => user.id === this.$route.params.id);
            await this.GetChildrenFromUser(this.$route.params.id).then(children => this.children = children);
        },
        computed: {
            ...mapGetters({
                getUsers: 'getUsers'
            })
        },
        methods: {
            ...mapActions([
                'GetChildrenFromUser',
            ]),
        }
    }
</script>